import { useWidget } from '@rango-dev/widget-embedded';
import { BLOCKCHAINS_THAT_SUPPORT_PROFILE, WALLETS_WITHOUT_SIGN_MESSAGE_METHOD, } from './useProfile.constants';
import { hashAccount } from './useProfile.helpers';
export function useProfile(params) {
    const { wallets: { details: walletsDetails }, } = useWidget();
    const hashedAddedAccounts = new Set(params?.addedAccounts?.map(hashAccount));
    const compatibleAccounts = walletsDetails
        .filter((walletDetail) => BLOCKCHAINS_THAT_SUPPORT_PROFILE.includes(walletDetail.chain) &&
        !WALLETS_WITHOUT_SIGN_MESSAGE_METHOD.includes(walletDetail.walletType) &&
        !hashedAddedAccounts.has(hashAccount({ blockchain: walletDetail.chain, address: walletDetail.address })))
        .map((walletDetail) => ({
        address: walletDetail.address,
        blockchain: walletDetail.chain,
        walletType: walletDetail.walletType,
    }));
    return {
        compatibleAccounts: compatibleAccounts ?? [],
        readyToSign: !!compatibleAccounts?.length,
    };
}
